import { render, staticRenderFns } from "./DashboardWater.vue?vue&type=template&id=290df9a6&scoped=true&"
import script from "./DashboardWater.vue?vue&type=script&lang=js&"
export * from "./DashboardWater.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWater.vue?vue&type=style&index=0&id=290df9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290df9a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
